/**@flow */

import React, { Component } from "react";
import { Icons, IconButton, Button, SectionComponent } from "@components";
import { localize } from "redux-i18n";
import { route, goToExternalUrl } from "@routes/helper";

import { RTWEmployeeDetailsView, RTWAbsenceDetailsView } from "../";
import { RTWInterviewForm } from "../";
import type { SelectedTask } from "@modules/reporting/reducer/tasks/types";

import "./styles.scss";

type OwnProps = $Exact<{
  toggleTasksSection: () => void,
  isTasksHidden: boolean,
  selectedTask: SelectedTask,
  clientId: number,
  employeeId?: number,
  isReports?: boolean,
}>;

type Props = $Exact<{
  ...PropsFromLocalize,
  ...OwnProps,
}>;

type ComponentState = $Exact<{
  questionDate: string,
  dateInterview: string,
  collapses: $Exact<{
    taskDetails: boolean,
    employeeDetails: boolean,
    absenceDetails: boolean,
  }>,
}>;

export class RTWTaskDetailsSection extends Component<Props, ComponentState> {
  state = {
    questionDate: "",
    dateInterview: "",
    collapses: {
      taskDetails: true,
      employeeDetails: true,
      absenceDetails: true,
    },
  };

  handleChangeQuestionDate = (questionDate: string) => {
    this.setState({ questionDate });
  };

  handleChangeDateInterview = (dateInterview: string) => {
    this.setState({ dateInterview });
  };

  handleViewRecordClick = () => {
    window.open(
      route("REPORTING_EMPLOYEE_ABSENCES_PATH", {
        clientId: this.props.clientId,
        employeeId: this.props.selectedTask.employee.id,
      }),
      "_blank",
    );
  };

  handlePrintForm = () => {
    const body = document.body;
    const bodyChildren = body.children;

    const print_form = document.createElement("div");
    if (!body || !print_form) return false;
    print_form.id = "temporary-content";
    print_form.innerHTML = document.getElementById("print_form")?.innerHTML || "";
    //$FlowIgnore
    for (let prop in bodyChildren) bodyChildren[prop]?.classList?.add("d-none");
    body.appendChild(print_form);
    window.print();
    //$FlowIgnore
    for (let prop in bodyChildren) bodyChildren[prop]?.classList?.remove("d-none");
    body.removeChild(print_form);
  };

  collapseBlock = (collapse: string) => {
    this.setState({
      collapses: {
        ...this.state.collapses,
        [collapse]: !this.state.collapses[collapse],
      },
    });
  };

  render() {
    return (
      <div id="print_form">
        <div className="section mb-4">
          <SectionComponent
            className="pl-0 pr-0"
            title={<h5>{this.props.t("EMPLOYEE_DETAILS")}</h5>}
            titleClassName="font-size-24px"
            wrapperClassName="collapsable options-items"
            onTitleClick={() => this.collapseBlock("employeeDetails")}
            isOpen={this.state.collapses.employeeDetails}
            collapsable
          >
            {this.props.selectedTask ? (
              <RTWEmployeeDetailsView selectedTask={this.props.selectedTask} />
            ) : null}
          </SectionComponent>
        </div>
        <div className="section mb-4">
          <SectionComponent
            className="pl-0 pr-0"
            title={<h5>{this.props.t("ABSENCE_DETAILS")}</h5>}
            titleClassName="font-size-24px"
            wrapperClassName="collapsable options-items"
            onTitleClick={() => this.collapseBlock("absenceDetails")}
            isOpen={this.state.collapses.absenceDetails}
            collapsable
          >
            {this.props.selectedTask ? (
              <RTWAbsenceDetailsView selectedTask={this.props.selectedTask} />
            ) : null}
          </SectionComponent>
        </div>
        <div className="section">
          <h4 className="font-weight-bold mb-3">{this.props.t("RTW_INTERVIEW")}</h4>
          <RTWInterviewForm
            clientId={this.props.clientId}
            onPrint={this.handlePrintForm}
            printForm={true}
            employeeId={this.props.employeeId}
            questionsData={this.props.selectedTask.questionAnswers}
            task={this.props.selectedTask}
            isReports={this.props.isReports}
          />
        </div>
      </div>
    );
  }
}

export default localize()(RTWTaskDetailsSection);
